import { MobileLink } from '../MobileLink'

export const MobileMenuLinks = ({
  items,
  onItemClick,
  featured = false,
  className = '',
}: MobileMenuLinksProps) => {
  if (items.length === 0) {
    return null
  }

  return (
    <div className={className} role="menu">
      {items.map(item => (
        <MobileLink
          key={item.href}
          href={item.href}
          onClick={onItemClick}
          featured={featured}
          highlighted={item.highlighted}
        >
          {item.name}
        </MobileLink>
      ))}
    </div>
  )
}

interface MobileMenuLinksProps {
  items: {
    name: string
    href: string
    highlighted?: boolean
  }[]
  onItemClick: () => void
  featured?: boolean
  className?: string
}
